import moment from 'moment'

/**
 * Process corporate events from backend API and map them to chart candle timestamps.
 * For daily/weekly/monthly timeframes ('D', 'W', 'M'): maps to matching candle date.
 * For intraday timeframes ('1m', '5m', '15m', '1h', etc.): maps to the FIRST candle of that trading day.
 */
export function processEventsForChart(events, candles, timeFrame = 'D') {
  if (!events || !Array.isArray(events) || !events.length || !candles || !candles.length) return []

  const isIntraday = timeFrame !== 'D' && timeFrame !== 'W' && timeFrame !== 'M'

  // Map candles by YYYY-MM-DD date -> first candle timestamp of that day
  const dateToFirstCandleTsMap = {}

  for (let i = 0; i < candles.length; i++) {
    const candle = candles[i]
    let ts = Array.isArray(candle) ? candle[0] : candle.date || candle.TimeStamp
    if (!ts) continue
    if (typeof ts === 'number' && ts < 10000000000) ts = ts * 1000

    const dateStr = moment(ts).format('YYYY-MM-DD')
    if (!dateToFirstCandleTsMap[dateStr]) {
      dateToFirstCandleTsMap[dateStr] = ts
    }
  }

  const chartEvents = []

  events.forEach((ev) => {
    if (!ev) return
    let rawDate = ev.eventDate || ev.event_date || ev.date || ev.exDate || ev.ex_date ||
                  ev.exDividendDate || ev.executionDate || ev.reportDate ||
                  ev.declarationDate || ev.paymentDate || ev.payDate
    if (rawDate === undefined || rawDate === null) return

    if (typeof rawDate === 'number' && rawDate < 10000000000) {
      rawDate = rawDate * 1000
    }

    const eventDateStr = moment(rawDate).format('YYYY-MM-DD')
    if (!eventDateStr || eventDateStr === 'Invalid date') return

    // Infer eventType if not explicitly provided
    let rawType = ev.eventType || ev.event_type || ev.type || ev.category || ev.kind || ''
    if (!rawType) {
      if (ev.ratio !== undefined || ev.splitTo !== undefined || ev.splitFrom !== undefined) {
        rawType = 'split'
      } else if (ev.epsEstimate !== undefined || ev.epsActual !== undefined) {
        rawType = 'earnings'
      } else {
        rawType = 'dividend'
      }
    }

    let targetTimestamp = null

    if (isIntraday) {
      // On intraday timeframe, icon MUST be on the FIRST candle of that day
      targetTimestamp = dateToFirstCandleTsMap[eventDateStr]
    } else {
      // On daily/weekly/monthly timeframe
      targetTimestamp = dateToFirstCandleTsMap[eventDateStr]
      if (!targetTimestamp) {
        targetTimestamp = new Date(rawDate).getTime()
      }
    }

    if (targetTimestamp && !isNaN(targetTimestamp)) {
      const normalizedEv = {
        ...ev,
        eventDate: ev.eventDate || rawDate,
        eventType: rawType.toString().toLowerCase()
      }
      chartEvents.push([targetTimestamp, normalizedEv])
    }
  })

  chartEvents.sort((a, b) => a[0] - b[0])
  return chartEvents
}
